<template lang="pug">
.study-result-list
  //- サイドメニュー部
  side-menu.study-result-list__side-menu(
    :currentLink='currentLink',
    :linkSettings='linkSettings',
    :linkEvent='sideMenuLinkEvent',
    :logoutEvent='logoutEvent'
  )
    template(#roleName)
      slot(name='roleName')
    template(#userUidTitle)
      slot(name='userUidTitle')
    template(#userNameSuffix)
      slot(name='userNameSuffix')
    template(#logoutText)
      slot(name='logoutText')
  //- コンテンツ表示部
  .study-result-list__content
    //- 画面タイトル
    text-frame.study-result-list__content__title.text-large.align-center
      slot(name='studyResultListTitle')
    //- 検索
    search-study.study-result-list__content__search(
      :searchEvent='searchEvent',
      :gradeSelectOptions='gradeSelectOptions',
      :yearSelectOptions='yearSelectOptions',
      :monthSelectOptions='monthSelectOptions',
      :gradeValue='gradeValue',
      :yearValue='yearValue',
      :monthValue='monthValue',
      :gradeChangeEvent='setGradeValue',
      :yearChangeEvent='setYearValue',
      :monthChangeEvent='setMonthValue'
    )
      template(#gradeLabel)
        slot(name='searchGradeLabel')
      template(#yearLabel)
        slot(name='searchYearLabel')
      template(#monthLabel)
        slot(name='searchMonthLabel')
      template(#searchButtonText)
        slot(name='searchButtonText')
    //- 一覧表示
    study-result-list-table.study-result-list__content__list(
      :studyResultList='studyResultList',
      :resultButtonEvent='resultButtonEvent',
      :lastMinuteCheckResultLinkEvent='lastMinuteCheckResultLinkEvent',
      :resolveResultLinkEvent='resolveResultLinkEvent',
      :downloadIconImage='downloadIconImage',
      :downloadEvent='downloadEvent',
      v-if='studyResultList'
    )
      template(#subjectHeader)
        slot(name='subjectHeader')
      template(#sUnitHeader)
        slot(name='sUnitHeader')
      template(#resultHeader)
        slot(name='resultHeader')
      template(#lastMinuteCheckResultHeader)
        slot(name='lastMinuteCheckResultHeader')
      template(#resolveResultHeader)
        slot(name='resolveResultHeader')
      template(#resultButtonLabel)
        slot(name='tableResultButtonLabel')
      template(#downloadLabel)
        slot(name='downloadLabel')
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import SideMenu from '@/components/organisms/student/SideMenu.vue'
import TextFrame from '@/components/atoms/TextFrame.vue'
import SearchStudy from '@/components/organisms/student/SearchStudy.vue'
import StudyResultListTable from '@/components/organisms/student/StudyResultListTable.vue'
import { LinkSetting } from '@/const/SideMenuSettings'
import { InputItem } from '@/models/inputItem'
import { StudyResultListType } from '@/models/studyResultListModel'

/**
 * テスト結果一覧画面テンプレート
 */
@Component({
  components: {
    SideMenu,
    TextFrame,
    SearchStudy,
    StudyResultListTable,
  },
})
export default class StudyResultList extends Vue {
  // このページのリンク設定
  @Prop()
  currentLink!: LinkSetting
  // サイドメニューリンク設定
  @Prop()
  linkSettings!: LinkSetting[]
  // サイドメニューリンク押下時のイベント
  @Prop()
  sideMenuLinkEvent!: Function
  // ログアウトボタン押下時のイベント
  @Prop()
  logoutEvent!: Function
  // 検索ボタン押下時イベント
  @Prop()
  searchEvent!: Function
  // 学年選択オプション
  @Prop()
  gradeSelectOptions!: InputItem[]
  // 実施年度選択オプション
  @Prop()
  yearSelectOptions!: InputItem[]
  // 実施月選択オプション
  @Prop()
  monthSelectOptions!: InputItem[]
  // テスト結果一覧表示情報
  @Prop()
  studyResultList!: StudyResultListType[]

  // 結果ボタン押下イベント
  @Prop()
  resultButtonEvent!: Function

  // 直前チェック結果リンク押下イベント
  @Prop()
  lastMinuteCheckResultLinkEvent!: Function

  // 解きなおし結果リンク押下イベント
  @Prop()
  resolveResultLinkEvent!: Function

  // ダウンロードリンクのアイコン画像
  @Prop()
  downloadIconImage!: string

  // ダウンロードリンク押下時イベント
  @Prop()
  downloadEvent!: Function

  // === 選択値を保持する変数群
  // 学年
  public gradeValue = ''
  // 実施年度
  public yearValue = ''
  // 実施月
  public monthValue = ''

  // 実施年度が変更された際呼び出し元にイベントを送信
  @Watch('yearValue')
  private yearUpdated() {
    this.$emit('yearUpdated')
  }

  // === 選択値をセットする関数群
  // 学年をセット
  private setGradeValue(value: string) {
    this.gradeValue = value
  }
  // 実施年度をセット
  private setYearValue(value: string) {
    this.yearValue = value
  }
  // 実施月をセット
  private setMonthValue(value: string) {
    this.monthValue = value
  }
}
</script>

<style lang="stylus" scoped>
.study-result-list
  display flex
  margin 0 20px
  padding 20px 0
  width 100%
  height 100%

  &__side-menu
    margin-right 20px

  &__content
    width calc(100% - 300px)

    &__title
      width 100%
      padding 20px
      background-color var(--color-default__box-background)
      margin-bottom 10px

    &__search
      margin-bottom 20px

    &__list
      margin-bottom 10px
</style>
